export default __webpack_public_path__ + "static/media/overdue-homework.6989446c.png";